import styled from 'styled-components';
import { UptimeBox } from '@uptime/uptime-component';
import { FONT_DEFAULT } from 'assets/fonts/fonts';

export const StyledAvatar = styled(UptimeBox)`
  ${({ theme }) => `
    .MuiAvatar-root {
      border: solid 2px ${theme.uptimeColors?.menuColors.mainMenu?.avatar || theme.uptimeColors.grayScales.white};
      border-radius: 50%;
      background-color: transparent !important;
      display: flex;
      justify-content: center;
      color: ${theme.uptimeColors?.menuColors.mainMenu?.avatar || theme.uptimeColors.grayScales.white};
      font-size: 14px;
      font-weight: bold;
      font-family: '${theme.uptimeFonts.primary || FONT_DEFAULT}' !important;
      padding-top: ${theme.uptimeDynamicAlignCenter.avatarUser.paddingTop};
    }
  `}
`;
